var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$route.name},[_c('div',{staticClass:"app-header"},[_c('app-f-header')],1),_c('div',{staticClass:"app-main"},[_vm._t("default"),_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('keep-alive',[_c('router-view')],1)],1)],2),(_vm.surveyUrl)?_c('page-questionnaire'):_vm._e(),_c('page-contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }